module.exports = __webpack_public_path__ + "lc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/lc.svg
// module id = 913
// module chunks = 0